// @flow
import React, { Component } from "react";
import { connect } from "react-redux";
import _ from "lodash";
import Scroll from "react-scroll";
import Actions from "../../actions/Creators";
import I18n from "../../i18n/I18n";
import Helper from "../../helper/Helper";
import Dropdown from "../../components/common/filterDropdown/Dropdown";
import {
  Layout,
  Loader,
  Button,
  Icon,
  ToggleButton,
  EmptyResults,
  SearchString,
  Pagination,
  LocaleLink,
  Modal
} from "../../components/common/";
import {
  ProductTable,
  PicklistTable,
  Print
} from "../../components/stockRequest";
import PrintReadyForPickup from "../../components/stockRequest/print/PrintItems";
import styles from "./StockRequest.scss";

class StockRequest extends Component {
  state = {
    limits: 100,
    page: 1,
    status: 1,
    picklistType: 1,
    selectedItems: [],
    warehouseOptions: [],
    selectedWarehouse: 1,
    modalOpen: false,
    search: "",
    sort: "",
    dir: "asc",
    sku_list: [],
    idWarehouse: null,
    isExport: false,
    formatted:
      this.props.pending &&
      this.props.pending.items &&
      !_.isEmpty(this.props.pending.items)
        ? this.props.pending.items
        : []
  };

  componentDidMount = () => {
    if (this.props.location && this.props.location.search) {
      this.getParams(this.props.location.search);
    }
    this.getWareHouses();

    if (this.props.user && this.props.seller) {
      if (this.props.match.params.picklistNr) {
        this.getPicklistItems();
      } else {
        this.getRequests();
      }
    }
  };

  openModal = () => {
    this.setState({
      modalOpen: true
    });
  };
  onCloseModal = () => {
    this.setState({
      modalOpen: false
    });
  };

  componentDidUpdate = (prevProps, prevState) => {
    if (
      this.props.location &&
      prevProps.location &&
      this.props.location !== prevProps.location &&
      this.props.location.search
    ) {
      this.getParams(this.props.location.search);
    }
    if (
      this.props.warehouses &&
      this.props.warehouses !== prevProps.warehouses
    ) {
      const { warehouses } = this.props;
      const newState = this.state;
      if (this.state.idWarehouse && warehouses && warehouses.warehouses) {
        const match = warehouses.warehouses.findIndex(
          warehouse =>
            warehouse &&
            Number(warehouse.id_warehouse) === Number(this.state.idWarehouse)
        );
        newState.selectedWarehouse = match + 1;
      }
      newState.warehouseOptions = warehouses && warehouses.warehouses;
      newState.change = true;
      this.setState(newState);
    }
    if (
      this.state.print &&
      this.props.printPicklistItems &&
      !prevProps.printPicklistItems
    ) {
      this.printPreview();
    }
    if (
      this.state.print &&
      this.props.readyForPickup &&
      this.props.readyForPickup.items &&
      !_.isEmpty(this.props.readyForPickup.items)
    ) {
      this.printPreview();
    }
    if (this.state.changeItems) {
      this.getPicklistItems();
    }
    if (
      this.props.pending !== prevProps.pending &&
      this.props.pending.items &&
      !_.isEmpty(this.props.pending.items)
    ) {
      const formatted = this.props.pending.items;
      this.setState({
        formatted
      });
    }
    if (this.state.change) {
      if (this.props.match.params.picklistNr) {
        this.getPicklistItems();
        this.setState({
          status: 2
        });
      } else {
        if (this.state.status === 1) {
          this.getRequests();
        } else if (this.state.status === 2) {
          this.getPicklists();
        } else if (this.state.status === 3) {
          this.getReadyForPickup();
        }
      }
    }
    if (
      (this.props.isUpdatedPicklist && !prevProps.isUpdatedPicklist) ||
      (this.props.isCreatedPicklist && !prevProps.isCreatedPicklist)
    ) {
      this.setState({
        change: true
      });
    }
    if (
      this.props.isCreatedPicklist &&
      !prevProps.isCreatedPicklist &&
      this.state.sku_list &&
      !_.isEmpty(this.state.sku_list)
    ) {
      this.markSelectedOutOfStock(this.state.sku_list);
    }
    if (
      (this.props.isMovedtoRFP && !prevProps.isMovedtoRFP) ||
      (this.state.picklistType === 2 && prevState.picklistType !== 2)
    ) {
      this.setState({
        status: 3,
        change: true
      });
      if (this.props.match.params.picklistNr) {
        this.props.history.push(`/${Helper.getLocale()}/stock-request`);
      }
    }
    if (this.props.isMarkedOutOfStock && !prevProps.isMarkedOutOfStock) {
      const newState = {};
      newState.status = 1;
      newState.change = true;
      newState.selectedItems = [];

      if (this.props.isCreatedPicklist) {
        newState.sku_list = [];
      }
      this.setState(newState);
    }
    if (
      this.props.match.params.picklistNr !==
        prevProps.match.params.picklistNr ||
      (!this.props.isCreatingPicklist &&
        this.props.isCreatingPicklist !== prevProps.isCreatingPicklist) ||
      (!this.props.isMovingtoRFP &&
        this.props.isMovingtoRFP !== prevProps.isMovingtoRFP)
    ) {
      const newState = {};
      newState.change = true;
      newState.search = "";
      this.setState(newState);
    }
    if (
      this.props.picklistItems &&
      !_.isEqual(this.props.picklistItems, prevProps.picklistItems) &&
      this.props.picklistItems.items &&
      !_.isEmpty(this.props.picklistItems.items) &&
      this.state.picklistType !== 2
    ) {
      const { warehouseOptions } = this.state;
      const match = warehouseOptions.findIndex(
        warehouse =>
          warehouse &&
          warehouse.id_warehouse ===
            this.props.picklistItems.items[0].id_partner_warehouse
      );
      const newState = {};
      newState.picklistType =
        this.props.picklistItems.items[0].status === "closed" ? 2 : 1;
      newState.page = 1;
      if (match >= 0) {
        newState.selectedWarehouse = match + 1;
      }
      this.setState(newState);
    }
  };

  componentWillReceiveProps = nextProps => {
    if (
      this.props.match !== nextProps.match ||
      this.props.seller !== nextProps.seller
    ) {
      this.getWareHouses();
    }
  };

  setPageUrl = () => {
    this.props.history.replace(`/${Helper.getLocale()}/stock-request`);
  };

  getParams = searchString => {
    const params = URLSearchParams ? new URLSearchParams(searchString) : "";
    const idWarehouse = params && params.get("id_warehouse");
    const status = params && params.get("status");
    const newState = {};
    if (status) {
      newState.status = Number(status);
    }
    if (idWarehouse) {
      newState.idWarehouse = idWarehouse;
    }
    if (status || idWarehouse) {
      newState.change = true;
      this.setPageUrl();
    }
    this.setState(newState);
  };

  getRequests = () => {
    const {
      page,
      limits,
      selectedWarehouse,
      warehouseOptions,
      idWarehouse,
      search,
      sort,
      dir
    } = this.state;
    const { warehouses } = this.props;
    let query = `limits=${limits}&page=${page}`;
    query = search ? `${query}&search=${search}` : query;
    if (idWarehouse) {
      query = `${query}&id_partner_warehouse=${idWarehouse}`;
    } else {
      query =
        selectedWarehouse && !_.isEmpty(warehouseOptions)
          ? `${query}&id_partner_warehouse=${
              warehouseOptions[selectedWarehouse - 1].id_warehouse
            }`
          : query;
    }
    query = sort ? `${query}&sort=${sort}` : query;
    query = sort && dir ? `${query}&dir=${dir}` : query;

    if (idWarehouse || (selectedWarehouse && !_.isEmpty(warehouseOptions))) {
      this.props.dispatch(Actions.getRequests(query));
    }
    this.setState({
      change: false
    });
  };

  getPicklists = () => {
    const {
      page,
      limits,
      picklistType,
      selectedWarehouse,
      warehouseOptions,
      search,
      idWarehouse
    } = this.state;
    const { warehouses } = this.props;
    let query = `limits=${limits}&page=${page}`;
    query = search ? `${query}&search=${search}` : query;
    if (idWarehouse) {
      query = `${query}&id_partner_warehouse=${idWarehouse}`;
    } else {
      query =
        selectedWarehouse && !_.isEmpty(warehouseOptions)
          ? `${query}&id_partner_warehouse=${
              warehouseOptions[selectedWarehouse - 1].id_warehouse
            }`
          : query;
    }
    if (picklistType === 2) {
      query = `${query}&status=closed`;
    }
    if (selectedWarehouse && !_.isEmpty(warehouseOptions)) {
      this.props.dispatch(Actions.getPicklists(query));
    }
    this.setState({
      change: false
    });
  };

  getReadyForPickup = print => {
    const {
      page,
      limits,
      selectedWarehouse,
      warehouseOptions,
      search,
      idWarehouse
    } = this.state;
    const { warehouses } = this.props;
    let query = `limits=${print ? "1000" : limits}&page=${print ? "1" : page}`;
    query = search ? `${query}&search=${search}` : query;
    if (idWarehouse) {
      query = `${query}&id_partner_warehouse=${idWarehouse}`;
    } else {
      query =
        selectedWarehouse && !_.isEmpty(warehouseOptions)
          ? `${query}&id_partner_warehouse=${
              warehouseOptions[selectedWarehouse - 1].id_warehouse
            }`
          : query;
    }
    query = print ? `${query}&print=1` : query;
    if (selectedWarehouse && warehouseOptions && !_.isEmpty(warehouseOptions)) {
      this.props.dispatch(Actions.getReadyForPickup(query));
    }
    this.setState({
      change: false
    });
  };

  getPicklistItems = () => {
    const { page, limits, search, isExport, changeItems, print } = this.state;
    const { picklistNr } = this.props.match.params;

    let query = `limits=${isExport || print ? 1000 : limits}&page=${
      isExport || print ? 1 : page
    }`;
    query = picklistNr ? `${query}&picklist_nr=${picklistNr}` : query;
    query = search ? `${query}&search=${search}` : query;
    query = isExport ? `${query}&is_export=1` : query;
    query = print ? `${query}&print=1` : query;
    if (picklistNr) {
      this.props.dispatch(Actions.getPicklistItems(query));
    } else if (changeItems) {
      query = changeItems ? `${query}&picklist_nr=${changeItems}` : query;
      this.props.dispatch(Actions.getPicklistItems(query));
    }
    this.setState({
      change: false,
      changeItems: null,
      isExport: false
    });
  };

  getWareHouses = () => {
    let query = "?is_owned=1";
    this.props.dispatch(Actions.getWareHouses(query));
  };

  createPicklist = () => {
    const payload = {
      id_partner_warehouse: this.state.warehouseOptions[
        this.state.selectedWarehouse - 1
      ].id_warehouse,
      stock_requested: this.state.selectedItems
    };
    if (
      this.state.selectedItems &&
      !_.isEmpty(this.state.selectedItems) &&
      this.state.selectedWarehouse &&
      this.props.seller &&
      !_.isEmpty(this.state.warehouseOptions)
    ) {
      this.props.dispatch(Actions.createPicklist(payload));
      this.onCloseModal();
    }
  };

  markReadyForPickup = () => {
    const payload = {
      id_partner_warehouse: this.state.warehouseOptions[
        this.state.selectedWarehouse - 1
      ].id_warehouse,
      picklist_nr: this.props.match.params.picklistNr
    };
    if (
      this.props.picklistItems &&
      this.props.picklistItems.items &&
      !_.isEmpty(this.props.picklistItems.items) &&
      this.state.selectedWarehouse &&
      !_.isEmpty(this.state.warehouseOptions)
    ) {
      this.props.dispatch(Actions.markReadyForPickup(payload));
    }
  };

  toggleStatus = status => {
    const newState = {};
    newState.status = status;
    newState.page = 1;
    newState.search = "";
    newState.selectedItems = [];
    newState.change = true;
    if (this.props.match.params.picklistNr) {
      this.props.history.push(`/${Helper.getLocale()}/stock-request`);
    }
    this.setState(newState);
  };

  perPage = e => {
    const newState = {};
    newState.limits = e;
    newState.page = 1;
    newState.change = true;
    this.setState(newState);
  };

  togglePicklistType = status => {
    const newState = {};
    newState.picklistType = status;
    newState.page = 1;
    newState.selectedItems = [];
    newState.sku_list = [];
    newState.change = true;
    this.setState(newState);
  };

  toggleWarehouse = wh => {
    const newState = this.state;
    newState.selectedWarehouse = wh;
    newState.page = 1;
    newState.selectedItems = [];
    newState.sku_list = [];
    newState.idWarehouse = this.state.warehouseOptions[wh - 1].id_warehouse;
    if (this.props.match.params.picklistNr) {
      this.props.history.push(`/${Helper.getLocale()}/stock-request`);
    }
    newState.change = true;
    this.setState(newState);
  };

  sortColumn = (sort, dir) => {
    const newState = {};
    newState.sort = sort;
    newState.dir = dir;
    newState.page = 1;
    newState.change = true;
    this.setState(newState);
  };

  toggleCheckbox = id => {
    const selectedItems = this.state.selectedItems;
    let { sku_list } = this.state;
    if (selectedItems) {
      const match = selectedItems.find(item => item && item.sku === id.sku);
      const matchOos = sku_list.find(item => item === id.sku);
      if (matchOos) {
        _.remove(sku_list, function(o) {
          return o === id.sku;
        });
      }
      if (match) {
        _.remove(selectedItems, function(o) {
          return o.sku === id.sku;
        });
      } else {
        selectedItems.push(id);
      }
    }
    const newState = {};
    newState.selectedItems = selectedItems;
    newState.sku_list = sku_list;

    newState.actionBox = !_.isEmpty(selectedItems);
    this.setState(newState);
  };

  onPageChange = page => {
    const newState = {};
    newState.page = page.selected + 1;
    newState.selectedItems = [];
    newState.sku_list = [];
    newState.change = true;
    this.setState(newState);
  };

  onSearch = search => {
    const newState = {};
    newState.page = 1;
    newState.search = search;
    newState.change = true;
    newState.selectedItems = [];
    newState.sku_list = [];
    this.setState(newState);
  };

  clearSearch = () => {
    const newState = {};
    newState.search = "";
    newState.change = true;
    newState.selectedItems = [];
    newState.sku_list = [];
    this.setState(newState);
  };

  onQtyChange = obj => {
    const selectedItems = this.state.selectedItems;
    const items =
      this.props.pending &&
      this.props.pending.items &&
      !_.isEmpty(this.props.pending.items)
        ? this.props.pending.items
        : [];
    // const preMatch = items.find(eachitem => eachitem && eachitem.sku === obj.sku);

    const formatted = items;
    for (let i = 0; i < items.length; i++) {
      if (items[i].sku === obj.sku) {
        formatted.qty = obj.qty;
      }
    }
    if (selectedItems) {
      const match = selectedItems.find(item => item && item.sku === obj.sku);
      if (match) {
        _.remove(selectedItems, function(o) {
          return o.sku === obj.sku;
        });
        selectedItems.push(obj);
      }
    }
    const newState = {};
    newState.selectedItems = selectedItems;
    newState.formatted = formatted;

    newState.actionBox = !_.isEmpty(selectedItems);
    this.setState(newState);
  };

  onOutOfStock = (obj, qty) => {
    let { sku_list } = this.state;

    const singleQtyList = [];

    if (qty !== 0) {
      const match = sku_list.find(item => item === obj);
      if (match) {
        _.remove(sku_list, function(o) {
          return o === obj;
        });
      }
      sku_list.push(obj);
    } else {
      singleQtyList.push(obj);
    }

    if (qty === 0) {
      this.markSelectedOutOfStock(singleQtyList);
    }
    const newState = {};
    newState.sku_list = sku_list;
    this.setState(newState);
  };

  onUpdateQty = payload => {
    this.props.dispatch(Actions.updatePicklistQty(payload));
  };

  markSelectedOutOfStock = sku_list => {
    const payload = {
      id_partner_warehouse: this.state.warehouseOptions[
        this.state.selectedWarehouse - 1
      ].id_warehouse,
      sku_list
    };
    this.props.dispatch(Actions.markOutOfStock(payload));
  };

  selectAll = () => {
    let items = this.state.formatted;
    if (this.props.match.params.picklistNr) {
      if (
        this.props.picklistItems &&
        this.props.picklistItems.items &&
        !_.isEmpty(this.props.picklistItems.items)
      ) {
        items = this.props.picklistItems.items;
      }
    }

    let selectedItems = this.state.selectedItems;
    if (
      selectedItems &&
      items &&
      !_.isEmpty(items) &&
      selectedItems.length < items.length &&
      this.props.seller
    ) {
      selectedItems = [];
      for (let i = 0; i < items.length; i++) {
        const obj = {
          id_partner: this.props.seller ? this.props.seller.id_partner : "",
          sku: items[i].sku,
          qty: items[i].qty || items[i].pending_qty
        };
        selectedItems.push(obj);
      }
    } else {
      selectedItems = [];
    }

    const newState = {};
    newState.selectedItems = selectedItems;
    newState.actionBox = !_.isEmpty(selectedItems);
    this.setState(newState);
  };

  exportPicklist = picklistNr => {
    const newState = {};
    newState.isExport = true;
    newState.changeItems = picklistNr;
    this.setState(newState);
  };

  printReadyForPickup = () => {
    this.getReadyForPickup(true);
    this.setState({
      print: true
    });
  };

  printCall = picklistNr => {
    const newState = {};
    newState.print = true;
    newState.changeItems = picklistNr;
    newState.picklistNr = picklistNr;
    this.setState(newState);
  };

  printPreview = () => {
    this.setState({
      print: false
    });
    if (this.state.status === 2) this.stock.onPrint();
    if (this.state.status === 3) this.pickupItems.onPrint();
  };

  setRef = ref => {
    this.stock = ref;
  };
  setRef2 = ref => {
    this.pickupItems = ref;
  };

  render() {
    const {
      warehouses,
      browser,
      pending,
      user,
      seller,
      isLoading,
      picklists,
      isSessionLoading,
      isWareHousesLoading,
      match,
      picklistItems,
      readyForPickup,
      isExporting,
      printPicklistItems,
      stocksCount,
      isNoonUser
    } = this.props;
    let { picklistNr } = match.params;
    const {
      status,
      selectedItems,
      search,
      picklistType,
      warehouseOptions,
      selectedWarehouse
    } = this.state;
    const statusTabs = [
      <div className={styles.tabTitle}>
        {I18n.getText("stock-request.pending")}
        <span className={styles.count}>
          ({stocksCount && stocksCount.counts && stocksCount.counts.pending})
        </span>
      </div>,
      <div className={styles.tabTitle}>
        {I18n.getText("stock-request.picklist")}
        <span className={styles.count}>
          ({stocksCount && stocksCount.counts && stocksCount.counts.picklist})
        </span>
      </div>,
      <div className={styles.tabTitle}>
        {I18n.getText("stock-request.readyforpickup")}
        <span className={styles.count}>
          (
          {stocksCount &&
            stocksCount.counts &&
            stocksCount.counts.readyforpickup}
          )
        </span>
      </div>
    ];

    const pageOptions = [
      {
        value: 100,
        key: 100,
        label: I18n.getText("stock-requests.per-page", { count: 100 })
      },
      {
        value: 150,
        key: 150,
        label: I18n.getText("stock-requests.per-page", { count: 150 })
      },
      {
        value: 200,
        key: 200,
        label: I18n.getText("stock-requests.per-page", { count: 200 })
      }
    ];

    const picklistTypes = [
      I18n.getText("stock-request.picking"),
      I18n.getText("stock-request.completed")
    ];
    let warehouseTabOptions = [];
    if (warehouseOptions) {
      for (let a = 0; a < warehouseOptions.length; a++) {
        warehouseTabOptions.push(warehouseOptions[a].code);
      }
    }

    let noOfPages = 0;

    if (picklistNr) {
      if (picklistItems && picklistItems.no_of_pages) {
        noOfPages = picklistItems.no_of_pages;
      }
    } else {
      if (status === 1 && pending && pending.no_of_pages) {
        noOfPages = pending.no_of_pages;
      } else if (status === 2 && picklists && picklists.no_of_pages) {
        noOfPages = picklists.no_of_pages;
      } else if (status === 3 && readyForPickup && readyForPickup.no_of_pages) {
        noOfPages = readyForPickup.no_of_pages;
      }
    }

    let searchLabel = "orders.new-search-placeholder";

    if (status === 2 && !picklistNr) {
      searchLabel = "stock-request.picklist-search";
    }

    const tempArr = selectedItems ? Array.from(selectedItems) : [];

    let previewItems = [];

    const pushSelected = item => {
      const tempMyObj = Object.assign({}, item);
      if (pending && pending.items && !_.isEmpty(pending.items)) {
        const match = pending.items.find(
          each => each && each.sku === tempMyObj.sku
        );

        if (match) {
          const tempMatch = Object.assign({}, match);

          tempMatch.qty = tempMyObj.qty;
          tempMatch.fulfilment_date = null;
          previewItems.unshift(tempMatch);
        }
      }
    };

    tempArr.forEach(pushSelected);

    return (
      <Layout
        currentIndex={11}
        title={"menu.stock-requests"}
        search={this.state.search}
        searchLabel={searchLabel}
        onSearch={this.onSearch}
      >
        {isSessionLoading ? (
          <Loader />
        ) : user && seller ? (
          !seller.is_allow_stock_request && !isNoonUser ? (
            this.props.history.push(`/${Helper.getLocale()}/orders`)
          ) : (
            <div className={styles.ctr}>
              <div className={styles.toggleCtr}>
                <ToggleButton
                  toggleBtn={this.toggleWarehouse}
                  tab
                  toggleItems={warehouseTabOptions}
                  selected={selectedWarehouse}
                />
              </div>
              <div className={styles.toggleCtr}>
                <ToggleButton
                  toggleBtn={this.toggleStatus}
                  fullWidth
                  tab
                  toggleItems={statusTabs}
                  selected={status}
                />
              </div>
              <div className={styles.flexer}>
                {picklistNr ? (
                  <div className={styles.backBtn}>
                    <LocaleLink to={`/stock-request`}>
                      <Icon
                        name={
                          Helper.getLang() === "ar" ? "fwd-arrow" : "back-arrow"
                        }
                      />
                    </LocaleLink>
                    <div className={styles.backTxt}>
                      <h5>{I18n.getText("stock-request.picklist-nr")}</h5>
                      <div>{picklistNr}</div>
                    </div>
                  </div>
                ) : (
                  ""
                )}
                {status === 3 &&
                readyForPickup &&
                readyForPickup.items &&
                !_.isEmpty(readyForPickup.items) ? (
                  <div className={styles.backBtn}>
                    <div className={styles.backTxt}>
                      <h5>{I18n.getText("transfers.asn")}</h5>
                      <div>{readyForPickup.items[0].asn_nr}</div>
                    </div>
                  </div>
                ) : (
                  ""
                )}
                <div className={styles.filters}>
                  {status === 1 && (
                    <Button
                      disabled={_.isEmpty(this.state.selectedItems)}
                      // onClick={() => this.createPicklist()}
                      onClick={() => this.openModal()}
                      icon="plus"
                    >
                      {I18n.getText("stock-request.create-picklist")}
                    </Button>
                  )}
                  {picklistNr &&
                    picklistItems &&
                    picklistItems.items &&
                    picklistType === 1 &&
                    !_.isEmpty(picklistItems.items) && (
                      <Button
                        // disabled={_.isEmpty(this.state.selectedItems)}
                        onClick={() => this.markReadyForPickup()}
                        icon="tick"
                      >
                        {I18n.getText("stock-request.confirm-readyforpickup")}
                      </Button>
                    )}
                  {status === 3 &&
                  readyForPickup &&
                  readyForPickup.items &&
                  !_.isEmpty(readyForPickup.items) ? (
                    <div className={styles.eachFilter}>
                      <Button
                        className={styles.printCtr}
                        onClick={() => this.printReadyForPickup()}
                      >
                        <Icon name="print" className={styles.printIcon} />
                        {isLoading ? (
                          <div className={styles.loader} />
                        ) : (
                          I18n.getText(
                            !_.isEmpty(this.state.selectedOrders)
                              ? "orders.print-selected"
                              : "orders.print-all"
                          )
                        )}
                      </Button>
                    </div>
                  ) : (
                    ""
                  )}
                  <div className={styles.dropdownCtr}>
                    <Dropdown
                      onChange={this.perPage}
                      selected={this.state.limits}
                      options={pageOptions}
                      label={I18n.getText("orders.display", {}, "Display")}
                    />
                  </div>
                </div>
              </div>
              <div>
                {search ? (
                  <SearchString
                    search={search}
                    clearSearch={this.clearSearch}
                  />
                ) : (
                  ""
                )}
              </div>
              <div>
                {status === 2 && !picklistNr && false ? (
                  <ToggleButton
                    toggleBtn={this.togglePicklistType}
                    tab
                    toggleItems={picklistTypes}
                    selected={picklistType}
                  />
                ) : (
                  ""
                )}
              </div>
              {picklistNr ? (
                <div>
                  {picklistItems &&
                  picklistItems.items &&
                  !_.isEmpty(picklistItems.items) ? (
                    isLoading ? (
                      <Loader />
                    ) : (
                      <ProductTable
                        data={picklistItems && picklistItems.items}
                        browser={browser}
                        status={status}
                        onUpdateQty={this.onUpdateQty}
                        searchString={search}
                        // toggleCheckbox={this.toggleCheckbox}
                        selectAll={this.selectAll}
                        seller={seller}
                        allSelected={
                          this.state.selectedItems.length ===
                          picklistItems.items.length
                        }
                        indeterminate={
                          this.state.selectedItems &&
                          !_.isEmpty(this.state.selectedItems) &&
                          this.state.selectedItems.length !==
                            picklistItems.items.length
                        }
                        selectedItems={selectedItems}
                        onQtyChange={this.onQtyChange}
                      />
                    )
                  ) : isLoading || isWareHousesLoading ? (
                    <Loader />
                  ) : (
                    <EmptyResults
                      heading={I18n.getText("stock-request.no-items")}
                    />
                  )}
                </div>
              ) : (
                <div>
                  {status === 1 ? (
                    isLoading || isWareHousesLoading ? (
                      <Loader />
                    ) : pending &&
                      pending.items &&
                      !_.isEmpty(pending.items) ? (
                      <ProductTable
                        data={pending && pending.items}
                        status={status}
                        browser={browser}
                        searchString={search}
                        sortColumn={this.sortColumn}
                        dir={this.state.dir}
                        sort={this.state.sort}
                        toggleCheckbox={this.toggleCheckbox}
                        selectAll={this.selectAll}
                        seller={seller}
                        dropdown
                        allSelected={
                          this.state.selectedItems.length ===
                          pending.items.length
                        }
                        indeterminate={
                          this.state.selectedItems &&
                          !_.isEmpty(this.state.selectedItems) &&
                          this.state.selectedItems.length !==
                            pending.items.length
                        }
                        selectedItems={selectedItems}
                        onQtyChange={this.onQtyChange}
                        onOutOfStock={this.onOutOfStock}
                      />
                    ) : isLoading || isWareHousesLoading ? (
                      <Loader />
                    ) : (
                      <EmptyResults
                        heading={I18n.getText("stock-request.no-items")}
                      />
                    )
                  ) : (
                    ""
                  )}
                  {status === 2 ? (
                    isLoading || isWareHousesLoading ? (
                      <Loader />
                    ) : picklists &&
                      picklists.picklists &&
                      !_.isEmpty(picklists.picklists) ? (
                      <div>
                        <PicklistTable
                          data={picklists.picklists}
                          browser={browser}
                          searchString={search}
                          isExporting={isExporting}
                          exportPicklist={this.exportPicklist}
                          printCall={this.printCall}
                        />
                      </div>
                    ) : isLoading || isWareHousesLoading ? (
                      <Loader />
                    ) : (
                      <EmptyResults
                        heading={I18n.getText("stock-request.no-picklists")}
                      />
                    )
                  ) : (
                    ""
                  )}
                  {status === 3 ? (
                    isLoading || isWareHousesLoading ? (
                      <Loader />
                    ) : readyForPickup &&
                      readyForPickup.items &&
                      !_.isEmpty(readyForPickup.items) ? (
                      <ProductTable
                        data={readyForPickup.items}
                        browser={browser}
                        searchString={search}
                      />
                    ) : isLoading || isWareHousesLoading ? (
                      <Loader />
                    ) : (
                      <EmptyResults
                        heading={I18n.getText("stock-request.no-items")}
                      />
                    )
                  ) : (
                    ""
                  )}
                </div>
              )}
              {noOfPages > 1 ? (
                <div className={styles.paginationWrapper}>
                  <Pagination
                    pageCount={noOfPages}
                    currentPage={this.state.page}
                    onPageChange={this.onPageChange}
                  />
                </div>
              ) : (
                ""
              )}
            </div>
          )
        ) : (
          <EmptyResults />
        )}
        <Modal
          contentLabel={"Preview"}
          isOpen={this.state.modalOpen}
          closeModal={() => this.onCloseModal()}
        >
          <h3 className={styles.titleModal}>
            {I18n.getText("stock-request.create-picklist")}
          </h3>
          <div className={styles.previewTable}>
            {previewItems && !_.isEmpty(previewItems) ? (
              isLoading ? (
                <Loader />
              ) : (
                <ProductTable
                  data={previewItems}
                  browser={browser}
                  searchString={search}
                />
              )
            ) : (
              ""
            )}
          </div>
          <div className={styles.btnCtr}>
            <Button
              className={styles.btn}
              variant="transparent"
              onClick={() => this.onCloseModal()}
            >
              {I18n.getText("transfers.cancel")}
            </Button>
            <Button onClick={() => this.createPicklist()}>
              {I18n.getText("product.confirm-btn")}
            </Button>
          </div>
        </Modal>
        {seller && (
          <div>
            <Print
              setRef={this.setRef}
              picklistItems={printPicklistItems && printPicklistItems.items}
              seller={seller}
            />
            <PrintReadyForPickup
              setRef={this.setRef2}
              lang={this.props.lang}
              selectedWarehouse={this.state.selectedWarehouse}
              selectedWarehouseDetails={
                warehouseOptions &&
                selectedWarehouse &&
                warehouseOptions[selectedWarehouse - 1]
              }
              seller={seller}
              selectedOrders={this.state.selectedOrders}
              status={this.state.status}
              printItems={readyForPickup && readyForPickup.items}
              currencyCode={seller.currency_code}
              warehouses={warehouses ? warehouses.warehouses : ""}
            />
          </div>
        )}
      </Layout>
    );
  }
}
const mapStateToProps = state => {
  return {
    lang: state.locale.lang,
    user: state.session.user,
    seller: state.session.seller,
    isNoonUser: state.session.isNoonUser,
    isSessionLoading: state.session.isSessionLoading,
    browser: state.browser,
    warehouses: state.session.ownedWarehouses,
    isWareHousesLoading: state.session.isWareHousesLoading,
    pending: state.stockRequest.pending,
    picklists: state.stockRequest.picklists,
    stocksCount: state.stockRequest.stocksCount,
    picklistItems: state.stockRequest.picklistItems,
    printPicklistItems: state.stockRequest.printPicklistItems,
    readyForPickup: state.stockRequest.readyForPickup,
    isLoading: state.stockRequest.isLoading,
    isPrinted: state.stockRequest.isPrinted,
    isCreatingPicklist: state.stockRequest.isCreatingPicklist,
    isUpdatedPicklist: state.stockRequest.isUpdatedPicklist,
    isCreatedPicklist: state.stockRequest.isCreatedPicklist,
    isExporting: state.stockRequest.isExporting,
    isMovingtoRFP: state.stockRequest.isMovingtoRFP,
    isMovedtoRFP: state.stockRequest.isMovedtoRFP,
    isMarkedOutOfStock: state.stockRequest.isMarkedOutOfStock,
    isMarkingOutOfStock: state.stockRequest.isMarkingOutOfStock
  };
};

export default connect(mapStateToProps)(StockRequest);



// WEBPACK FOOTER //
// ./src/containers/stockRequest/StockRequest.js